import { render, staticRenderFns } from "./ScenarioSection.vue?vue&type=template&id=2a8051e5"
import script from "./ScenarioSection.vue?vue&type=script&lang=js"
export * from "./ScenarioSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports